import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import FastClick from "fastclick";
import VueI18n from "vue-i18n";
import messages from "./assets/lang/index.js";
import VueQriously from "vue-qriously";
import StorageService from 'libs/storage'
import Util from 'libs/utils'
import WechatService from 'libs/wechat'
import ApiService from '@/api'
import {Dialog,Toast,Skeleton,Lazyload,Icon,Button} from 'vant';
Vue.use(StorageService)
Vue.use(Util)
Vue.use(ApiService)
Vue.use(WechatService)
Vue.use(VueI18n);
Vue.use(Dialog);
Vue.use(Skeleton);
Vue.use(Icon);
Vue.use(Lazyload);
Vue.use(Button);
Vue.prototype.$dialog = Dialog;
Vue.prototype.$toast = Toast;
Vue.use(VueQriously);


FastClick.attach(document.body);
Vue.config.productionTip = false;
(function (doc) {
    var docEl = doc.documentElement,
        recalc = function () {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            docEl.style.fontSize =  (clientWidth / 7.50) + "px";
        };
    if (!doc.addEventListener) return;
    doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);


const i18n = new VueI18n({
    locale: "cn",
    messages
});
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
